import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=5861c0b4&scoped=true&"
import script from "./menu-group.vue?vue&type=script&lang=js&"
export * from "./menu-group.vue?vue&type=script&lang=js&"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=5861c0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861c0b4",
  null
  
)

export default component.exports